import { useTravelerPickerContextV2 } from "../../../../../providers/TravelerPickerContextV2";
import { MAX_FLIGHT_TRAVELER, MAX_HOTEL_TRAVELER } from "../constants";
import { useDisableTravelerPicker } from "../Provider/DisableTravelerPickerContext";

export function useCheckEmployeeDisabled() {
  const { employees, nonEmployeeAdults, nonEmployeeChildren } =
    useDisableTravelerPicker();
  const { type } = useTravelerPickerContextV2();

  const MAX_TRAVELER =
    type === "flight" ? MAX_FLIGHT_TRAVELER : MAX_HOTEL_TRAVELER;
  const nonEmployeeCount =
    (nonEmployeeAdults || 0) + (nonEmployeeChildren || 0);

  return nonEmployeeCount + employees.length >= MAX_TRAVELER;
}
